const fbFontChanger = [
  'A tool that transforms plain text into eye-catching fonts. Elevate your posts with creative styles, from elegant to playful. ',
  'Simply input your text, choose a font, and stand out in the digital crowd. Express yourself uniquely on social media like Facebook, Twitter(X) with this user-friendly generator.', 
  'Make every word a visual delight – try it now!'
]

const fancyText = [
  `The use of special characters in names has become a trend, enabling young individuals to establish a unique personal style that sets them apart from others.`,
  `This is particularly crucial for gamers, as having a distinctive and impressive gaming handle is always a point of interest.`,
  `We are here to help you create the most unique and standout names. Whether you're looking for a cool gaming alias or a distinct online persona, we've got you covered!`
]

const descContants = {
  fbFontChanger: fbFontChanger,
  fancyText: fancyText
}

export default descContants;
